import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import {
	isClientFetchError,
	isHttpClientErrorStatusCode,
} from '@atlassian/jira-fetch/src/utils/is-error.tsx';
import { extractStatusCode } from '@atlassian/jira-software-sla-tracker/src/services/status-code/index.tsx';
import { VALIDATION_ERROR_NAME } from '@atlassian/jira-fetch/src/utils/errors.tsx';

/**
 * Abstracted Helper with GasV2 and GasV3 errors
 */
export const trackClientFetchError = (
	location: string,
	message: string,
	error: TypeError,
): void => {
	fireErrorAnalytics({
		error,
		attributes: { message },
		meta: { id: location, packageName: 'jiraIssueViewCommonUtils' },
	});
};

export const trackOrLogClientError = (
	location: string,
	message: string,
	error: Error | TypeError,
): void => {
	if (error instanceof TypeError && isClientFetchError(error)) {
		trackClientFetchError(location, message, error);
	} else {
		log.safeErrorWithoutCustomerData(location, message, error);
	}
};

/**
 * In issue view, we capture all client side errors as abortable errors.
 * We don't count these in our SLOs and have separate detectors!
 * Reference: https://hello.atlassian.net/wiki/spaces/~7120206209a776922841c6bc6056b740cf36f4/pages/5216279701
 * Since isClientFetchError doesn't check for ValidationError, we need to check for it here.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isAbortableError = (error: any) => {
	const statusCode = extractStatusCode(error);
	if (
		isHttpClientErrorStatusCode(statusCode) ||
		(!statusCode && isClientFetchError(error)) ||
		error?.name === VALIDATION_ERROR_NAME
	) {
		return true;
	}
	return false;
};
